import React from 'react';
import moment from 'moment-timezone';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';

import styles from './DocumentRow.module.scss';
import DocumentActions from './DocumentOption';
import { DocumentAttachment } from '@spike/client-model';

function formatCreatedOn(date: string): string {
    return moment(date).format('MM/DD/YYYY, h:mm a');
}

export interface DocumentRowProps {
    document: DocumentAttachment;
    onDownload: (doc: DocumentAttachment) => void;
    onRename: (doc: DocumentAttachment) => void;
    onDelete: (doc: DocumentAttachment) => void;
}

export const DocumentRow: React.FC<DocumentRowProps> = ({ document, onDownload, onRename, onDelete }) => {
    return (
        <TableRow key={document.id}>
            <TableCell className={styles.nameCell}>{document.filename}</TableCell>
            <TableCell className={styles.dateCell}>{formatCreatedOn(document.createdAt.toString())}</TableCell>
            <TableCell className={styles.ownerCell}>{document.ownerName}</TableCell>
            <TableCell
                isActions
                className={styles.actionsCell}
            >
                <DocumentActions
                    document={document}
                    onDownload={onDownload}
                    onRename={onRename}
                    onDelete={onDelete}
                />
            </TableCell>
        </TableRow>
    );
};

export default DocumentRow;
